/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Helper Serializer that is used to validate that the JSON manual_shares-data
 * provided to the SharepointCreationSerializer contains the necessary fields.
 * @export
 * @interface APIManualShareJSONRequest
 */
export interface APIManualShareJSONRequest {
    /**
     * 
     * @type {string}
     * @memberof APIManualShareJSONRequest
     */
    comment: string;
    /**
     * 
     * @type {string}
     * @memberof APIManualShareJSONRequest
     */
    password: string;
}

/**
 * Check if a given object implements the APIManualShareJSONRequest interface.
 */
export function instanceOfAPIManualShareJSONRequest(value: object): value is APIManualShareJSONRequest {
    if (!('comment' in value) || value['comment'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function APIManualShareJSONRequestFromJSON(json: any): APIManualShareJSONRequest {
    return APIManualShareJSONRequestFromJSONTyped(json, false);
}

export function APIManualShareJSONRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIManualShareJSONRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'],
        'password': json['password'],
    };
}

export function APIManualShareJSONRequestToJSON(value?: APIManualShareJSONRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'password': value['password'],
    };
}

